import { z } from "zod"
import type { PrintShopDefinition } from "@/types/domain"

export const brazilianStates = [
  ["AC", "Acre"], ["AL", "Alagoas"], ["AP", "Amapá"], ["AM", "Amazonas"],
  ["BA", "Bahia"], ["CE", "Ceará"], ["DF", "Distrito Federal"], ["ES", "Espírito Santo"],
  ["GO", "Goiás"], ["MA", "Maranhão"], ["MT", "Mato Grosso"], ["MS", "Mato Grosso do Sul"],
  ["MG", "Minas Gerais"], ["PA", "Pará"], ["PB", "Paraíba"], ["PR", "Paraná"],
  ["PE", "Pernambuco"], ["PI", "Piauí"], ["RJ", "Rio de Janeiro"], ["RN", "Rio Grande do Norte"],
  ["RS", "Rio Grande do Sul"], ["RO", "Rondônia"], ["RR", "Roraima"], ["SC", "Santa Catarina"],
  ["SP", "São Paulo"], ["SE", "Sergipe"], ["TO", "Tocantins"],
] as const

export const printShopSchema = z.object({
  name: z.string().trim().min(2, "Informe o nome da gráfica.").max(120, "Use até 120 caracteres."),
  city: z.string().trim().max(120, "Use até 120 caracteres."),
  state: z.string().trim().refine((value) => !value || brazilianStates.some(([code]) => code === value), "Selecione um estado válido."),
  address: z.string().trim().max(500, "Use até 500 caracteres."),
  email: z.string().trim().pipe(z.union([z.literal(""), z.email("Informe um email válido.").max(254, "Use até 254 caracteres.")])),
  phone: z.string().trim().max(40, "Use até 40 caracteres."),
  whatsapp: z.string().trim().max(40, "Use até 40 caracteres."),
  attendant: z.string().trim().max(120, "Use até 120 caracteres."),
})

export type PrintShopFormValues = z.infer<typeof printShopSchema>

export function printShopToInput(shop?: Partial<PrintShopDefinition>): PrintShopFormValues {
  return {
    name: shop?.name ?? "", city: shop?.city ?? "", state: shop?.state ?? "",
    address: shop?.address ?? "", email: shop?.email ?? "", phone: shop?.phone ?? "",
    whatsapp: shop?.whatsapp ?? "", attendant: shop?.attendant ?? "",
  }
}
